import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { DateConstants } from "utils/constants";
import { AccountingFormTypes } from "models/formTypes";
//#endregion
//#region components
import { useFilterContext, ViewPanel } from "components/common";
import BalanceReportAssetsSummaryPieChart from "./widgets/assetsSummaryPieChart";
import BalanceReportDebtSummaryPieChart from "./widgets/debtSummaryPieChart";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const StandardBalanceReportCharts: React.FC = () => {
  const { filter } = useFilterContext<AccountingFormTypes.FinancialReportFilter>();

  const getChartTitle = (titleKey: string): string => {
    const endMonth = filter?.monthRange?.end;
    if (!endMonth) return "";

    return LocalizationHelperInstance.getFormattedMessage(titleKey, "", {
      monthYear: LocalizationHelperInstance.getFormattedDate(endMonth, DateConstants.MonthYearShortConfig),
    });
  };

  return (
    <>
      <ViewPanel
        title={getChartTitle(TranslationKeys.Accounting.AssetAllocation)}
        appearance="sm"
        gridSize="md"
        isCanvasContent
      >
        <BalanceReportAssetsSummaryPieChart />
      </ViewPanel>
      <ViewPanel
        title={getChartTitle(TranslationKeys.Accounting.LiabilityAllocation)}
        appearance="sm"
        gridSize="md"
        isCanvasContent
      >
        <BalanceReportDebtSummaryPieChart />
      </ViewPanel>
    </>
  );
};

export default StandardBalanceReportCharts;
